import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import IProductVariation from "@/interfaces/variation.interface";
import productVariationService from "@/services/variation.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetProductVariationByIdReturn = RequestsBaseReturn<IProductVariation | null>;

export type UseGetProductVariationByIdProps = ByIdRequestProps;

type UseSwrGetProductVariationByIdParams = [string, number];

const useGetProductVariationById = ({
  _id,
}: UseGetProductVariationByIdProps): UseGetProductVariationByIdReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<IProductVariation, Error, UseSwrGetProductVariationByIdParams | null>(
    _id ? [SWR_KEYS.getProductVariationById, _id] : null,
    ([, variationId]) => productVariationService.getById(variationId),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetProductVariationById;
